/*eslint-disable */

let $ = window.jQuery;

$(document).ready(function () {
    let $carousel = $('.js-c-carousel');
    if ($carousel.length > 0) {
        $carousel.slick({
            arrows          : true,
            dots            : true,
            slidesToShow    : 4,
            slidesToScroll  : 4,
            autoplay        : false,
            prevArrow       : '<button type="button" class="slick-prev slick-arrow" aria-label="Prev"></button>',
            nextArrow       : '<button type="button" class="slick-next slick-arrow" aria-label="Next"></button>',
            responsive: [
                {
                breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true
                    }
                },
                {
                breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
});

/*eslint-ensable */
